import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from 'components/Common/Loader/Loader';
import { useMediaServer } from 'hooks/useMediaServer';
import { apiUrls } from 'services/api-urls';
import { replaceByLinkEnv } from 'services/formatter';
import styles from './ProductSizeGuide.module.scss';

/**
 * Product page of website. Contains details product data.
 */
function ProductSizeGuide({
  sizeGuide,
  handleContentHeight,
}: {
  sizeGuide: string;
  handleContentHeight?: () => void;
}): JSX.Element {
  const { t } = useTranslation(['productPage']);
  const hasSizeGuide = parseInt(sizeGuide) >= 1;

  const { content: htmlContent, error } = useMediaServer(
    hasSizeGuide ? apiUrls.getProductSizeGuide(sizeGuide) : null
  );

  useEffect(() => {
    if (typeof handleContentHeight === 'function') handleContentHeight();
  }, [htmlContent]);

  if (hasSizeGuide && !htmlContent && !error) {
    return <Loader />;
  }

  if (!htmlContent) {
    return t('LABEL_TAB_SIZE_GUIDE_NO_EXISTING');
  }

  return (
    <div
      className={styles.sizeGuide}
      dangerouslySetInnerHTML={{
        __html: replaceByLinkEnv(htmlContent),
      }}
    />
  );
}

export default ProductSizeGuide;
